import * as React from "react";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import CyPortfolioReturn from "../../../components/Charts/CyPortfolioReturn";
import HighLevelDisclosure from "./HighLevelDisclosure";
import {END_OF_CPR_YEAR} from "../../../utilities/cpr";

const StrategyRiskMetrics = (props) => {
  const { portfolio, baseChartData, bdIsCambridge, accessLevel } = props;
  const { cprRecommendation, metadata } = portfolio;

  const useWbiSingleStrategy = ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(metadata.managerType);
  const managerList = cprRecommendation.managers;
  const strategyStartDate = moment(baseChartData[0].date)
    .startOf("month")
    .subtract(2, "months");
  const dateValue = END_OF_CPR_YEAR.toDate().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <section
      className={"content"}
      data-toc={"Cy Optimized Portfolio Annualized Performance"}
    >
      <Grid
        container={true}
        spacing={3}
        className={"sub-content"}
        data-toc={"Annualized Return"}
      >
        <Grid item={true} xs={12}>
          <Typography variant="h4">
            Cy Optimized Portfolio Annualized Performance
          </Typography>
          <Typography variant="h5" gutterBottom={true}>
            Hypothetical Illustration
          </Typography>
        </Grid>
        <Grid item={true} xs={12}>
          <Typography variant="h5">
            Annualized Return<sup>*</sup>
          </Typography>
          <Typography variant="h6" gutterBottom={true}>
            for the date range ending {dateValue}
          </Typography>
          <CyPortfolioReturn
            startDate={strategyStartDate.format("MM/DD/YYYY")}
            managerList={managerList}
            portfolioDisplayName={cprRecommendation.displayName || ""}
            portfolioSummary={cprRecommendation.summary}
            useWbiSingleStrategy={useWbiSingleStrategy}
            forPrinting={true}
            bdIsCambridge={bdIsCambridge}
            accessLevel={accessLevel}
          />
          <HighLevelDisclosure showClause={[1, 3]} />
        </Grid>
      </Grid>
    </section>
  );
};

export default StrategyRiskMetrics;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/StrategyReturnMetrics.jsx